import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

export type ApiKeyResponse = {};

const APP_CREATE_APIKEY_API_VERSION = 0;

export const createApiKey = async (appId: string, deploymentId: string) => {
    const url = `${API_URL}/saas/${appId}/deployment/apikey`;

    const result = await httpNetworking.simplePOSTRequest(url, { deploymentId }, {}, APP_CREATE_APIKEY_API_VERSION);

    return result.data as ApiKeyResponse;
};
